import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/setups',
  component: Layout,
  redirect: '/setups',
  name: 'setups',
  meta: {
    title: '设置',
    icon: 'setup',
  },
  children: [
    {
        path: 'contact',
        name: 'contactIndex',
        component: () => import('@/views/user/contact.vue'),
        meta: {
            title: '联系信息',
            breadcrumb: true,
            auth: [
                'User.Contact.menu'
            ]
        }
    },
    // {
    //     path: 'invoice',
    //     name: 'invoiceIndex',
    //     component: () => import('@/views/merchant/invoice.vue'),
    //     meta: {
    //         title: '发票信息',
    //         breadcrumb: true,
    //         auth: [
    //             'Merchant.Invoice.menu'
    //         ]
    //     }
    // },
    {
        path: 'account',
        name: 'accountIndex',
        component: () => import('@/views/user/account.vue'),
        meta: {
            title: '账号管理',
            breadcrumb: true,
            auth: [
                'User.Account.menu'
            ]
        }
    },
    {
        path: 'company',
        name: 'companyIndex',
        component: () => import('@/views/merchant/company.vue'),
        meta: {
            title: '公司信息',
            breadcrumb: true,
            auth: [
                'Merchant.Company.menu'
            ]
        }
    }
  ],
}

export default routes
